import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    POWER_BI_LINK: {
        url: "power-bi/fetch-link",
        method: "get",
    },
};

export const usePowerBiLink = () =>
    useApiFetcherSWR(API_ENDPOINT.POWER_BI_LINK);